module.exports = __webpack_public_path__ + "static/media/deal3.d565f290.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deal3.png
// module id = 18
// module chunks = 0